import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectIcon from '../../../../assets/icons/SelectIcon';
import { Option, SuggestionsContainer, CheckMarkWrapper } from './Search.style';
import { FilterOption } from '../../../../types';
import { AvailableFiltersCount } from '../../../../types/oneGraphTypes';

type SuggestionsListProps = {
  suggestions: AvailableFiltersCount[];
  focusedOptionIndex: number;
  setFocusedOptionIndex: (value: React.SetStateAction<number>) => void;
  handleSuggestionClick: (suggestion: string) => void;
};

const SuggestionsList: React.FC<SuggestionsListProps> = ({
  suggestions,
  focusedOptionIndex,
  setFocusedOptionIndex,
  handleSuggestionClick,
}) => {
  const { t } = useTranslation();
  return (
    <SuggestionsContainer>
      {suggestions.map((model, index) => (
        <Option
          data-testid={`suggestion-${model.value}`}
          key={model.value}
          focused={index === focusedOptionIndex}
          data-focused={index === focusedOptionIndex}
          onMouseOver={() => setFocusedOptionIndex(index)}
          onClick={() => handleSuggestionClick(model.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSuggestionClick(model.value);
            }
          }}
        >
          <CheckMarkWrapper focused={index === focusedOptionIndex}>
            <SelectIcon />
          </CheckMarkWrapper>
          <span>{t(`vlp.filters.filterOptions.modelFamily.${model.id}`)}</span>
        </Option>
      ))}
    </SuggestionsContainer>
  );
};

export default SuggestionsList;
